import { useMemo } from 'react'
import { TabsLayout } from '@/layouts/TabsLayout'
import { Select } from '@/components/Select'
import { useInstitutionCampaignSelect } from '@/hooks/useInstitutionCampaignSelect'
import {
  MetaConversionsLayoutContextProvider,
  type MetaConversionsLayoutContextValue,
} from './MetaConversionsLayoutContext'
import styles from './MetaConversionsLayout.module.css'

export function MetaConversionsLayout() {
  const {
    campaignOptions,
    campaignValue,
    handleCampaignValueChange,
    selectPlaceholder,
    campaignsLoading,
    campaignsError,
    persistError,
    isSelectorDisabled,
    isAdminWithoutInstitution,
    campaignId,
    selectedCampaign,
  } = useInstitutionCampaignSelect()

  const contextValue = useMemo<MetaConversionsLayoutContextValue>(
    () => ({
      campaignId,
      campaignValue,
      selectedCampaign,
      setCampaignValue: handleCampaignValueChange,
      campaignsLoading,
      hasCampaigns: campaignOptions.length > 0,
      isAdminWithoutInstitution,
    }),
    [
      campaignId,
      campaignValue,
      selectedCampaign,
      handleCampaignValueChange,
      campaignsLoading,
      campaignOptions.length,
      isAdminWithoutInstitution,
    ]
  )

  const headerAction = (
    <div className={styles.campaignSelector}>
      <Select
        id="meta-conversions-campaign-select"
        value={campaignValue}
        onChange={handleCampaignValueChange}
        options={campaignOptions}
        placeholder={selectPlaceholder}
        label="Campanha"
        icon="mdi:bullhorn"
        disabled={isSelectorDisabled}
      />
      {campaignsError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {campaignsError}
        </p>
      ) : null}
      {persistError ? (
        <p className={styles.campaignSelectorError} role="alert">
          {persistError}
        </p>
      ) : null}
    </div>
  )

  return (
    <MetaConversionsLayoutContextProvider value={contextValue}>
      <TabsLayout
        title="Conversões"
        subtitle="Painéis e histórico separados por Meta (Facebook) e Google Analytics 4 por campanha"
        headerAction={headerAction}
        tabs={[
          {
            value: 'dashboard-meta',
            label: 'Dashboard Meta',
            icon: 'mdi:facebook',
            to: '/conversoes-meta',
          },
          {
            value: 'dashboard-google',
            label: 'Dashboard Google',
            icon: 'mdi:google-analytics',
            to: '/conversoes-meta/google',
          },
          {
            value: 'eventos-meta',
            label: 'Eventos Meta',
            icon: 'mdi:table-large',
            to: '/conversoes-meta/eventos/meta',
          },
          {
            value: 'eventos-google',
            label: 'Eventos Google',
            icon: 'mdi:table-cog',
            to: '/conversoes-meta/eventos/google',
          },
        ]}
      />
    </MetaConversionsLayoutContextProvider>
  )
}
